import { HeroUIProvider, ToastProvider } from '@heroui/react';

export default function Providers({ children }) {
  return (
    <HeroUIProvider>
      <ToastProvider
        toastProps={{
          timeout: '3000',
        }}
        toastOffset={85}
        placement="top-center"
      />
      {children}
    </HeroUIProvider>
  );
}
